import React from "react";

import {
  Button,
  TableBody,
  TableBodyProps,
  TableCell,
  TableRow,
  Typography,
  colors,
  makeStyles,
} from "@material-ui/core";
import { formatDateShort } from "@ds-developer/frontend";

import { Test } from "@hubcapp/types";
import { TestDetailsTableProps } from "../types";
import { getStatus } from "@ds-developer/test-details-modal";

const sortTestsByDateAsc = (a: Test, b: Test) =>
  new Date(a.date).getTime() - new Date(b.date).getTime();

const useStyles = makeStyles(theme => ({
  sectionTitleCell: {
    paddingTop: theme.spacing(3),
    borderBottom: "none",
  },
  sectionTitle: {
    fontSize: "14px",
    color: colors.grey[900],
    fontWeight: theme.typography.fontWeightBold,
  },
}));

const TestDetailsTable: React.FC<TestDetailsTableProps & TableBodyProps> = ({
  title,
  tests,
  editClickHandler,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <TableBody {...rest}>
      <TableRow>
        <TableCell colSpan={3} classes={{ root: classes.sectionTitleCell }}>
          <Typography component="h6" className={classes.sectionTitle}>
            {title}
          </Typography>
        </TableCell>
      </TableRow>
      {tests.sort(sortTestsByDateAsc).map(test => {
        const { id, date, status, editable } = test;
        return (
          <TableRow key={id} data-test="learner-test">
            <TableCell
              data-test={`learner-test-date-${
                new Date(date) > new Date(Date.now()) ? "booking" : "history"
              }`}
            >
              {formatDateShort(new Date(date))}
            </TableCell>
            <TableCell data-test="learner-test-status">
              <Typography variant="body2">
                {getStatus({ date, status })}
              </Typography>
            </TableCell>
            <TableCell align="right">
              {editable && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => editClickHandler(test)}
                  data-test="learner-test-edit-button"
                >
                  Edit
                </Button>
              )}
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};

export default TestDetailsTable;
